__turbopack_context__.v({
  "grayscale": "styles-module-scss-module__9g-P8G__grayscale",
  "inactive-grayscale": "styles-module-scss-module__9g-P8G__inactive-grayscale",
  "picture-container-1": "styles-module-scss-module__9g-P8G__picture-container-1",
  "picture-container-2": "styles-module-scss-module__9g-P8G__picture-container-2",
  "picture-container-3": "styles-module-scss-module__9g-P8G__picture-container-3",
  "picture-container-4": "styles-module-scss-module__9g-P8G__picture-container-4",
  "picture-container-border-1": "styles-module-scss-module__9g-P8G__picture-container-border-1",
  "picture-container-border-2": "styles-module-scss-module__9g-P8G__picture-container-border-2",
  "picture-container-border-3": "styles-module-scss-module__9g-P8G__picture-container-border-3",
  "picture-container-border-4": "styles-module-scss-module__9g-P8G__picture-container-border-4",
});
